import { guideKind, guideOpenUrl, guideFileUrl } from '../../services/guides'
import PdfViewer from '../pdf/PdfViewer'
import './guideView.css'

// Adaptive guide renderer that fills its container: images, video, and PDFs show
// in place; web URLs embed in an iframe; other file types get an open link.
// Shared by the Guides tab's viewer windows and the GuideViewerModal.
export function GuideView({ guide }) {
  if (!guide) return null
  const kind = guideKind(guide)
  const src = guideOpenUrl(guide)
  const title = guide.title || guide.name || 'Guide'

  if (kind === 'image') {
    return (
      <div className="guide-view">
        <img className="guide-view-img" src={src} alt={title} />
      </div>
    )
  }
  if (kind === 'video') {
    return (
      <div className="guide-view">
        <video className="guide-view-video" src={src} controls />
      </div>
    )
  }
  if (kind === 'pdf') {
    return (
      <div className="guide-view guide-view-pdf">
        <PdfViewer fileUrl={guideFileUrl(guide.fileId)} />
      </div>
    )
  }
  if (kind === 'url') {
    return (
      <div className="guide-view">
        <iframe className="guide-view-frame" src={src} title={title} />
      </div>
    )
  }
  return (
    <div className="guide-view guide-view-fallback">
      <p>This file type can’t be previewed here.</p>
      <a className="ct-btn ct-btn-primary" href={src} target="_blank" rel="noopener noreferrer">
        Open file
      </a>
    </div>
  )
}

export default GuideView
